module.exports = __webpack_public_path__ + "img/banner.b0eddea7.jpg";